module.exports = __webpack_public_path__ + "img/cat.ce447ab5.png";